var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7363 7.84961C24.9641 7.84973 25.1503 8.03586 25.1504 8.26367C25.1504 8.49158 24.9642 8.67762 24.7363 8.67773H20.6641V13.0137C20.6641 13.2417 20.478 13.4277 20.25 13.4277H15.9141V17.7637C15.9141 17.9917 15.728 18.1777 15.5 18.1777H11.1641V22.5137C11.1641 22.7417 10.978 22.9277 10.75 22.9277H6.26367C6.03579 22.9276 5.84961 22.7416 5.84961 22.5137C5.84973 22.2859 6.03586 22.0997 6.26367 22.0996H10.3359V17.7637C10.3361 17.5358 10.5221 17.3496 10.75 17.3496H15.0859V13.0137C15.0861 12.7858 15.2721 12.5996 15.5 12.5996H19.8359V8.26367C19.8361 8.03579 20.0221 7.84961 20.25 7.84961H24.7363Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsIcon);
export default __webpack_public_path__ + "static/media/steps-icon.7f26c9504a86ccd83ebca71e3c797552.svg";
export { ForwardRef as ReactComponent };